<template>
  <div class="singleProContainer">
    <article>
      <a href="#">
        <figure>
          <div class="fillter"></div>
          <div class="img-container">
            <img src="images/banners/prog.jpg" alt="program img"/>
          </div>
          <figcaption>
            <h1>جرين بلازا</h1>

            <h2 class="price">الاسكندريه</h2>
          </figcaption>
          <!-- <div class="ribbon">
              <span>عرض خاص</span>
          </div> -->
        </figure>
      </a>
    </article>
  </div>
</template>
<script type="text/javascript">
  export default {
    name:'SingleProg'
  }
</script>
